import React from 'react';
import InfoIcon from './InfoIcon';
import ShowCurrencies from '../../../utils/showCurrencies';

const ProductGrid = ({
  items,
  quantities,
  priceLookup,
  showProductsOneRow,
  openDescriptionId,
  toggleDescription,
  onAdd,
  onRemove,
  onQuantityChange,
}) => {
  if (items.length === 0) {
    return (
      <div className="flex justify-center items-center w-[300px] h-[200px]">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#00A3DA]" />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-2 gap-2 md:gap-4 mt-5 items-start">
      {' '}
      {/* Added items-start */}
      {items.map(item => {
        const quantity = quantities[item.creator]?.quantity || 0;
        const price = item[priceLookup.toLowerCase()] || item.usd || 0;

        return (
          <div key={item.id} className=" bg-white rounded-lg p-1  flex flex-col min-h-0" tabIndex={0}>
            {/* Main card content */}
            <div className="flex flex-col w-full min-h-0">
              <div className={`flex ${showProductsOneRow ? '' : 'flex-col'} items-center w-full`}>
                <div className="flex items-center w-full justify-between">
                  <p className="flex-1 font-bold text-[15px] text-left text-[#00A3DA] whitespace-normal">
                    {item.name.length > 25 ? `${item.name.slice(0, 18)}...` : item.name}
                  </p>
                  <InfoIcon
                    className="w-5 h-5 flex-shrink-0 ml-2 cursor-pointer"
                    onClick={e => {
                      e.stopPropagation();
                      toggleDescription(item.id);
                    }}
                  />
                </div>

                <div className="flex items-center w-full sm:ml-1 mt-1">
                  <img src={item.image_link} alt={item.name} className={` block w-16 h-16 object-cover mr-2  rounded-[5px]`} />
                  <div className="flex flex-col items-start w-full justify-center">
                    <p className="font-brandingBold text-[17px] text-[#00A3DA] bg-[#E9F7FF] py-0.5 px-1 rounded-lg w-full">
                      {ShowCurrencies(priceLookup, quantity > 0 ? Number(price) * quantity : Number(price))}
                    </p>
                    <div className="flex w-full mt-1 bg-[#E9F7FF] justify-between p-1 rounded-lg">
                      <button
                        onClick={e => {
                          e.stopPropagation();
                          onRemove(item);
                        }}
                      
                        className={`w-7 h-7 bg-[#00A3DA] rounded-lg flex items-center justify-center text-white text-[24px] font-bold leading-none ${
                          quantity < 1 ? 'opacity-50 cursor-not-allowed' : ''
                        }`}
                        disabled={quantity < 1}
                      >
                        –
                      </button>
                      <input
                        type="number"
                        min={0}
                        value={quantity}
                        onClick={e => e.stopPropagation()}
                        onChange={e => {
                          const val = parseInt(e.target.value, 10);
                          onQuantityChange(item, isNaN(val) ? 0 : Math.max(0, val));
                        }}
                        className="w-12 text-center bg-transparent focus:outline-none text-[#00A3DA] font-bold"
                      />
                      <button
                        onClick={e => {
                          e.stopPropagation();
                          onAdd(item);
                        }}
                        
                        className="w-7 h-7 bg-pink rounded-lg flex items-center justify-center text-white text-[24px] font-bold leading-none"
                      >
                        <img src="https://cdn.builder.io/api/v1/image/assets%2F32b8c354d4bc455dbf10fed3923dfae1%2Ffbf397a88f3f44a3956db6b7db7e1ed9" alt="+" className="w-3 h-3" />
                      </button>
                    </div>
                  </div>
                </div>

                <div className="flex w-full items-center justify-end ml-auto mt-1">
                  <button
                    onClick={e => {
                      e.stopPropagation();
                      onAdd(item);
                    }}
                    className="bg-pink text-white flex justify-center items-center rounded-[5px] px-2 h-7 w-full"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>

            {/* Description that expands independently */}
            {openDescriptionId === item.id && (
              <div className="mt-1 text-xs p-2 text-[#00A3DA] font-branding">{item.short_description || item.description}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ProductGrid;
